<script>
import HallForm from "@/views/menu/hall/hallForm";
import Component, { mixins } from "vue-class-component";
import { toastService } from "@/services/toastService.js";

@Component({
  inject: {
    hallService: "hallService",
    fileUploadService: "fileUploadService",
  }
})
export default class HallEdit extends mixins(HallForm) {
  formId = "edit-hall-form";

  get fieldColumns() {
    return 2;
  }
  get actions() {
    return [
      {
        id: "save",
        type: "submit",
        text: this.translations.labels.button_save,
        leftIcon: "mdi-content-save-outline",
        disabled: () => {
          return this.fileUploadService.isUploading();
        },
        handle: this.save,
      },
    ];
  }
  async save(action, passesValidation) {
    this.errors = [];
    if (!passesValidation) {
      return;
    }
    try {
        await this.hallService.update(this.model.id, {
        idHall: this.model.id,
        idEvent: this.model.idEvent,
        code: this.model.code,
        localizations: this.model.localizations,
      });
       this.$router.push("/hall/list");
      toastService.success(this.translations.success.hall_update);
    } catch (error) {
      this.errors = this.formatApiErrors(error);
    }
  }

  getFormTitle() {
    return this.translations.pageTitles.halls_edit;
  }

  async afterCreate () {
    this.model = await this.hallService.read(this.$route.params.id);
    this.isReady = true;
  }
}
</script>
